import { Slider } from "@mui/material";
import styles from '../../ProductsRPDesigner.module.scss';
import { sliderElements } from "../../responsePage/rptemplate";

function CSSlider ({components, handleSlide, selectedComponentIndex}) {

    return (
      <>
        {sliderElements.map((el) => {
          if (components[selectedComponentIndex]?.[el.name] !== undefined) {
            return (
              <div
                key={el.name}
                className={styles["sec--products--rpdesigner--colors--element"]}
              >
                <div
                  className={
                    styles["sec--products--rpdesigner--colors--element--left"]
                  }
                >
                  {el.label}
                </div>
                <div style={{ width: "80px" }}>
                  <Slider
                    id={el.name}
                    data-testid={el.name}
                    size="small"
                    defaultValue={el.defaultValue}
                    value={components[selectedComponentIndex]?.[el.name]}
                    min={el.minValue}
                    max={el.maxValue}
                    aria-label="Small"
                    valueLabelDisplay="auto"
                    onChange={(e, newValue) => handleSlide(newValue, el.name)}
                  />
                </div>
              </div>
            );
          }
        })}
      </>
    );
}

export default CSSlider;